var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpawnLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 15,
    viewBox: "0 0 120 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iii_294_1124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8457 5.68063C19.8873 5.59773 21.4391 7.15214 21.3564 10.1988C21.439 13.2419 19.8909 14.7756 16.8564 14.6965C16.8506 14.6964 16.8457 14.701 16.8457 14.7068C16.8457 14.7124 16.8411 14.717 16.8355 14.717H1.83083C1.27854 14.717 0.830827 14.2693 0.830827 13.717V12.3594C0.830827 11.8072 1.27854 11.3594 1.83083 11.3594H15.7077C16.494 11.3802 16.8871 10.9864 16.8664 10.1988C16.8871 9.41123 16.494 9.01745 15.7077 9.03817H4.49314C1.45156 9.10035 -0.0795792 7.56666 0.00318498 4.51999C-0.0795792 1.47333 1.45156 -0.0603585 4.49314 0.00181742H19.5287C20.081 0.00181742 20.5287 0.449533 20.5287 1.00182V2.35936C20.5287 2.91165 20.081 3.35936 19.5287 3.35936H5.63115C4.84489 3.33864 4.45176 3.73242 4.47245 4.51999C4.45176 5.30757 4.84489 5.70135 5.63115 5.68063H16.8457Z",
    fill: "url(#paint0_radial_294_1124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8327 0.00181742C42.8742 -0.0603585 44.4261 1.47333 44.3433 4.51999C44.4261 7.56666 42.8742 9.10035 39.8327 9.03817H28.4594C27.9071 9.03817 27.4594 9.48589 27.4594 10.0382V13.6963C27.4594 14.2485 27.0117 14.6963 26.4594 14.6963H23.9901C23.4379 14.6963 22.9901 14.2485 22.9901 13.6963V1.00182C22.9901 0.449533 23.4379 0.00181742 23.9901 0.00181742H39.8327ZM39.8327 5.68063C40.6189 5.70135 41.0327 5.30757 41.0121 4.51999C41.0327 3.73242 40.6189 3.33864 39.8327 3.35936H28.4594C27.9071 3.35936 27.4594 3.80708 27.4594 4.35936V4.68063C27.4594 5.23291 27.9071 5.68063 28.4594 5.68063H39.8327Z",
    fill: "url(#paint1_radial_294_1124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0136 0.00181742C58.2414 0.00181742 61.1795 1.8464 62.5865 4.74798L66.7455 13.2571C67.0702 13.9215 66.5865 14.6963 65.8471 14.6963H62.8168C62.4352 14.6963 62.0869 14.4791 61.9189 14.1365L61.3298 12.9348C61.1618 12.5922 60.8135 12.375 60.4319 12.375H49.5953C49.2137 12.375 48.8653 12.5922 48.6974 12.9348L48.1082 14.1365C47.9403 14.4791 47.5919 14.6963 47.2103 14.6963H44.1801C43.4406 14.6963 42.957 13.9215 43.2817 13.2571L47.4407 4.74798C48.8477 1.8464 51.7858 0.00181742 55.0136 0.00181742ZM51.3064 7.60043C50.983 8.26466 51.4667 9.03817 52.2055 9.03817H57.8217C58.5605 9.03817 59.0442 8.26466 58.7208 7.60043L57.3724 4.83088C56.9172 3.91895 56.0068 3.35936 55.0136 3.35936C54.0204 3.35936 53.0893 3.91895 52.6548 4.83088L51.3064 7.60043Z",
    fill: "url(#paint2_radial_294_1124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9838 10.4061C87.3847 10.4061 87.7469 10.1666 87.9039 9.79766L91.814 0.610221C91.971 0.241296 92.3332 0.00181742 92.7341 0.00181742H95.2372C95.9539 0.00181742 96.4379 0.733599 96.1574 1.39315L90.7592 14.0876C90.6023 14.4567 90.24 14.6963 89.839 14.6963H83.5448C83.1451 14.6963 82.7838 14.4583 82.626 14.0911L81.7611 12.0783C81.4136 11.2698 80.2666 11.2719 79.9221 12.0817L79.0688 14.0877C78.9118 14.4567 78.5496 14.6963 78.1486 14.6963H71.8372C71.4357 14.6963 71.0732 14.4561 70.9165 14.0865L65.5361 1.39205C65.2567 0.732638 65.7407 0.00181742 66.4569 0.00181742H68.9619C69.3628 0.00181742 69.725 0.241296 69.882 0.610221L73.7921 9.79766C73.9491 10.1666 74.3112 10.4061 74.7122 10.4061H75.2929C75.6941 10.4061 76.0564 10.1663 76.2133 9.79706L78.1788 5.17044C78.3356 4.8012 78.698 4.56145 79.0992 4.56145H82.5968C82.998 4.56145 83.3604 4.8012 83.5172 5.17044L85.4827 9.79706C85.6396 10.1663 86.0019 10.4061 86.4031 10.4061H86.9838Z",
    fill: "url(#paint3_radial_294_1124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.04 4.31274C102.488 4.31274 102.04 4.76045 102.04 5.31274V13.6963C102.04 14.2485 101.592 14.6963 101.04 14.6963H98.5709C98.0186 14.6963 97.5709 14.2485 97.5709 13.6963V1.00182C97.5709 0.449533 98.0186 0.00181742 98.5709 0.00181742H104.66C104.954 0.00181742 105.233 0.130785 105.423 0.354531L113.659 10.0533C113.849 10.2771 114.127 10.4061 114.421 10.4061H114.51C115.062 10.4061 115.51 9.95834 115.51 9.40606V1.00182C115.51 0.449533 115.958 0.00181742 116.51 0.00181742H119C119.552 0.00181742 120 0.449533 120 1.00182V13.6963C120 14.2485 119.552 14.6963 119 14.6963H112.889C112.596 14.6963 112.318 14.5676 112.128 14.3443L103.891 4.6647C103.701 4.44141 103.423 4.31274 103.13 4.31274H103.04Z",
    fill: "url(#paint4_radial_294_1124)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iii_294_1124",
    x: 0,
    y: 0,
    width: 120,
    height: 18.717,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_294_1124"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_294_1124",
    result: "effect2_innerShadow_294_1124"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_294_1124",
    result: "effect3_innerShadow_294_1124"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_294_1124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60 14.717) rotate(-90) scale(19.9613 118.521)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_294_1124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60 14.717) rotate(-90) scale(19.9613 118.521)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_294_1124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60 14.717) rotate(-90) scale(19.9613 118.521)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_294_1124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60 14.717) rotate(-90) scale(19.9613 118.521)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_294_1124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60 14.717) rotate(-90) scale(19.9613 118.521)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpawnLogo);
export default __webpack_public_path__ + "static/media/spawn-logo.767df8a1754b8dbdfcd9f5d994f6c496.svg";
export { ForwardRef as ReactComponent };